import { Component, Injectable, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { BankDetailsComponent } from '../bank-details/bank-details.component';
import { AlertService } from 'src/app/_alert';
import { delay } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-update-bank',
  templateUrl: './update-bank.component.html',
  styleUrls: ['./update-bank.component.css']
})
export class UpdateBankComponent implements OnInit {
  disabledControl: boolean = false;
  submitted: boolean = true;
  bankUser: any;
  status: boolean = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  isLoading: boolean = false;
  isButtonDisabled = false;
  breakpoint: number;

  constructor(
    private authService: AuthService,
    private loginService: LoginService,
    private alertService: AlertService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getData();
  }

 token = this.authService.getToken();

  getData() {
    this.isLoading = true;
    this.loginService.allBankDetails('', '')
      .subscribe((response: any[]) => {
        if (response.length == 0) {
          this.router.navigate(['/All/bankdetails']);
        }
        this.bankUser = response;
        this.customerBankAccountSetupForm.disable();
        this.customerBankAccountSetupForm = new FormGroup(
          {
            NameOfBank: new FormControl(this.bankUser[this.bankUser.length - 1].nameOfBank),
            BankRoutingNumber: new FormControl(this.bankUser[this.bankUser.length - 1].bankRoutingNumber),
            CompanyTaxId: new FormControl(this.bankUser[this.bankUser.length - 1].companyTaxId),
            BankAddress: new FormControl(this.bankUser[this.bankUser.length - 1].bankAddress),
            // PaymentEmailAddress: new FormControl(this.bankUser[this.bankUser.length - 1].paymentEmailAddress, [
            //   Validators.email,
            //   Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
            AccountNumber: new FormControl(this.bankUser[this.bankUser.length - 1].accountNumber, [Validators.required]),
            ConfirmAccNum: new FormControl(this.bankUser[this.bankUser.length - 1].accountNumber, [Validators.required]),
            AccountType: new FormControl(this.bankUser[this.bankUser.length - 1].accountType),
            PaymentSelection: new FormControl(this.bankUser[this.bankUser.length - 1].paymentSelection),
            BankZipCode: new FormControl(this.bankUser[this.bankUser.length - 1].bankZipCode, [
             
              Validators.minLength(5),
              Validators.maxLength(7)]),
            BankContactPhone: new FormControl(this.bankUser[this.bankUser.length - 1].bankContactPhone, [
              
              Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')]),
            CompanyId: new FormControl(this.bankUser[this.bankUser.length - 1].companyId),
            VendorType: new FormControl(this.bankUser[this.bankUser.length - 1].vendorType),
            BankContact: new FormControl(this.bankUser[this.bankUser.length - 1].bankContact),
            CustomerId: new FormControl(this.bankUser[this.bankUser.length - 1].customerId),
            CreatedBy: new FormControl(this.bankUser[this.bankUser.length - 1].createdBy),
            W9Verified: new FormControl(this.bankUser[this.bankUser.length - 1].w9Verified),
            W9VerifiedYear: new FormControl(this.bankUser[this.bankUser.length - 1].w9VerifiedYear),
            CompanyRegistrationId: new FormControl(this.bankUser[this.bankUser.length - 1].companyRegistrationId)
          }
        )
        console.log(this.bankUser);
        this.isLoading = false;
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      })
  }

  customerBankAccountSetupForm: FormGroup = new FormGroup(
    {
      NameOfBank: new FormControl('', [Validators.required]),
      BankRoutingNumber: new FormControl('', [Validators.required]),
      CompanyTaxId: new FormControl(''),
      BankAddress: new FormControl(''),
      // PaymentEmailAddress: new FormControl('', [
      //   Validators.email,
      //   Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      AccountNumber: new FormControl('', [Validators.required]),
      ConfirmAccNum: new FormControl('', Validators.required),
      AccountType: new FormControl(''),
      PaymentSelection: new FormControl(''),
      BankZipCode: new FormControl('', [
        Validators.minLength(5),
        Validators.maxLength(7)]),
      BankContactPhone: new FormControl('', [
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')]),
      CompanyId: new FormControl('companyId'),
      VendorType: new FormControl('VendorType'),
      BankContact: new FormControl('BankContact'),
      CustomerId: new FormControl('', [Validators.required]),
      CreatedBy: new FormControl(''),
      W9Verified: new FormControl(true),
      W9VerifiedYear: new FormControl('w9VerifiedYear'),
      CompanyRegistrationId: new FormControl('')
    }
  )

  onUpdate() {
    if (!this.status) {
      this.customerBankAccountSetupForm.enable();
      this.status = true;
    }
    else {
      this.submitted = true;
      this.isLoading = true;
      if (this.customerBankAccountSetupForm.valid) {
        if (this.customerBankAccountSetupForm.value.AccountNumber == this.customerBankAccountSetupForm.value.ConfirmAccNum) {
          this.loginService.updateBankAccount(this.customerBankAccountSetupForm.value, this.token)
            .subscribe((response) => {
              console.log(response);
              this.customerBankAccountSetupForm.disable();
              this.status = false;
              setTimeout(() => {
                this.isLoading = false;
              }, 200);
              this.alertService.success('Success!! Bank Details updated SuccessFully.', this.options);
            }, (err) => {
              console.log(err);
              this.alertService.error(err.error.errors.Messages[0], this.options);
              this.isLoading = false;
            })
        }
        else {
          this.alertService.error('Error!! Account number and confirm account number should be same.', this.options);
          this.isLoading = false;
        }
      }
      else {
        console.log('Please Enter valid data');
        // this.alertService.error('Error :( Please Enter Valid Details !', this.options);
        this.isLoading = false;
      }
    }
  }

  get forms() {
    return this.customerBankAccountSetupForm.controls;
  }

  reset() {
    this.customerBankAccountSetupForm.disable();
    this.status = false;
  }

  onDelete() {
    const id = this.customerBankAccountSetupForm.value.CompanyRegistrationId;
    const token = this.authService.getToken();
    this.loginService.deleteBankAccount(id, token).subscribe((response) => {
      console.log(response);
      this.alertService.info('Bank details deleted SuccessFully!', this.options);
    }, (error) => {
      console.log(error);
    })
  }

   //bank acc routing num
   routingNum() {
    this.loginService.createBankAccountRoutingNum(this.customerBankAccountSetupForm.value.BankRoutingNumber, this.token).
      subscribe((response: any) => {
        console.log(response);
        console.log(response.bankName);
        this.customerBankAccountSetupForm.patchValue({
          NameOfBank: response.bankName,
          BankRoutingNumber: response.routingNumber,
          BankAddress: response.address,
          BankZipCode: response.zip,
          BankContactPhone: response.telePhone,
        });
        if (response.message !== 'OK') {
          this.alertService.error(response.message, this.options);
        }
      }, (err) => {
        console.log(err);
      })
  }


  onPress(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.customerBankAccountSetupForm.value.BankContactPhone = event.target.value
    }
  }

  routingNumValidations(event) {
    const inputValue = event.target.value;
    const maxDigits = 8;
    if (event.target.value.length > 8) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.customerBankAccountSetupForm.value.BankRoutingNumber = event.target.value
    }
  }

}

